import React from "react";
import "../animations/animate.css";
import AnimatedBody from "../animations/AnimatedBody";
import AnimatedTitle from "../animations/AnimatedTitle";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import AnimatedTools from "../animations/AnimatedTools.tsx";
import { WeatherFx } from "../animations/Weather";

const Tools = () => {
  const tools = [
    { name: "TypeScript", src: "/icons/typescript.lottie" },
    { name: "React", src: "/icons/react.lottie" },
    { name: "Next.js", src: "/icons/next.lottie" },
    { name: "Tailwind CSS", src: "/icons/tailwind.lottie" },
    { name: "PostgreSQL", src: "/icons/postgres.lottie" },
    { name: "Python", src: "/icons/python.json" },
    { name: "Django", src: "/icons/django.lottie" },
    { name: "Figma", src: "/icons/figma.json" },
    { name: "API", src: "/icons/api.lottie" },
    { name: "DevOps", src: "/icons/cicd.json" },
    { name: "Git", src: "/icons/Git.lottie" },
    { name: "Docker", src: "/icons/docker.lottie" },
  ];

  return (
    <section
      className="relative z-10 w-full items-center justify-center overflow-hidden bg-[#0E1016] bg-cover bg-center pt-16 pb-36 md:pt-20 md:pb-44 lg:pt-20 lg:pb-56"
      id="tools"
    >
      {/* Weather animation overlay */}
      <WeatherFx
        position="absolute"
        top={0}
        left={0}
        width={"100%"}
        height={"100%"}
        pointerEvents="none"
        zIndex={0}
        type="rain"
        intensity={35}
        speed={1}
        angle={12}
        colors={["#a8a39d"]}
      />
      <div className="mx-auto flex w-[90%] flex-col lg:max-w-[1212.8px]">
        <AnimatedTitle
          text={"TOOLS IM USING."}
          className={
            "mb-10 text-left text-[40px] font-bold leading-[0.9em] tracking-tighter text-[#e4ded7] sm:text-[45px] md:mb-16 md:text-[60px] lg:text-[80px]"
          }
          wordSpace={"mr-[14px]"}
          charSpace={"mr-[0.001em]"}
        />

        <div className="mx-auto w-[100%] lg:max-w-[1200px] justify-center">
          <div className="flex w-[100%] flex-wrap gap-6 md:gap-8">
            <AnimatedTools
              className="grid grid-cols-4 gap-10 md:gap-12 w-full"
              delay={0.2}
              stepSize={0.05}
              iconSize={50}
            >
              {tools.map((tool) => (
                <div
                  key={tool.name}
                  className="flex flex-col items-center gap-3"
                >
                  <div className="flex w-28 items-center justify-center">
                    <DotLottieReact src={tool.src} autoplay loop />
                  </div>
                  <p className="text-xs mb-10 md:text-sm text-[#a8a39d] text-center">
                    {tool.name}
                  </p>
                </div>
              ))}
            </AnimatedTools>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tools;
